import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  manager: null,
  defaultFileStatus: null,
  defaultFolders: null,
  registryRights: [],
  availableStatuses: null,
  table: {
    search: "",
    limit: 11,
    page: 1,
    pages: 1,
    sort: "",
    data: [],
    searchFields: [
      { key: "index", name: "global:leasing.index" },
      { key: "leasingNumber", name: "global:leasing.leasingNumber" },
      { key: "contact.name", name: "global:leasing.leasingContact" },
      { key: "monthWorth", name: "global:leasing.monthWorth" },
    ],
    selectedSearchFields: [
      "title",
      "leasingNumber",
      "index",
      "contact.name",
      "monthWorth",
    ],
    dictionaryFields: ["leasingType"],
    url: "leasing",
  },
};

const leasingReducer = createSlice({
  name: "leasingReducer",
  initialState,
  reducers: {
    setRegistryRights: (state, { payload }) => {
      state.registryRights = payload;
    },
    updateManager: (state, { payload }) => {
      state.manager = payload;
    },
    updateDefaultFileStatus: (state, { payload }) => {
      state.defaultFileStatus = payload;
    },
    updateDefaultFolders: (state, { payload }) => {
      state.defaultFolders = payload;
    },
    updateAvailableStatuses: (state, { payload }) => {
      state.availableStatuses = payload;
    },
    updateRegistry: (state, { payload }) => {
      state.table = { ...state.table, ...payload };
    },
    clearRegistry: () => initialState,
  },
  extraReducers: {},
});

export const {
  updateRegistry,
  clearRegistry,
  updateManager,
  updateDefaultFileStatus,
  updateDefaultFolders,
  updateAvailableStatuses,
  setRegistryRights,
} = leasingReducer.actions;

export default leasingReducer.reducer;
